import { useState, useEffect } from 'react';
import { Button, Modal, Form, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import API from '../../../Services/API';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import { useCurrentCompanyID } from '../../../hooks/useCurrentCompany';

function AdvanceLinesSearch(props) {
  const [modalShow, setModalShow] = useState(false);
  const [search, setSearch] = useState(props.query.trim());
  const [field, setField] = useState('documentNo');
  const [lines, setLines] = useState([]);
  const companyId = useCurrentCompanyID();

  const dispatch = useDispatch();

  async function searchOrder() {
    if (search.trim() !== '') {
      let url = '';
      let filter = '';
      url = 'purchase_order_lines';
      let vendorConfirmationFilter = '';
      let vendorFilter = '';
      if (props.vendorType === 'Warehouse') {
        vendorFilter = `whseVendorCode eq '${props.vendorNo}'`;
      } else {
        vendorConfirmationFilter = ' and vendConfirmationSent eq true';
        vendorFilter = `vendorNo eq '${props.vendorNo}'`;
      }
      filter = `${vendorFilter}${vendorConfirmationFilter} and contains(${field},'${search}')`;

      const params = {
        company_id: companyId,
        $filter: filter
      };
      dispatch(loaderActions.show());
      const res = await API().get(`/${url}`, { params });
      if (res.data.value.length > 0) {
        setLines(res.data.value);
      } else {
        setLines([]);
        toast.error('No PO line found');
      }
      dispatch(loaderActions.hide());
    } else {
      setLines([]);
      toast.error(`Please enter PO Line SKU code`);
    }
  }
  const ordersList = lines.map((line, index) => {
    return (
      <Link
        to={`/purchase-order/${props.vendorType}/${line.documentNo}`}
        key={index}
        target="_blank"
      >
        <ListGroup.Item>
          {line.lineNo} &nbsp; {line.itemNo}
        </ListGroup.Item>
      </Link>
    );
  });

  useEffect(() => {
    async function updateSearch() {
      if (modalShow === true && props.query !== '') {
        await searchOrder();
      }
    }
    updateSearch();
  }, [modalShow]);

  return (
    <div>
      <OverlayTrigger
        key="upload"
        className="mr-2 "
        placement={'top'}
        overlay={
          <Tooltip id={`tooltip-upload`} role={'button'}>
            Advanced Search
          </Tooltip>
        }
      >
        <i
          className="feather icon-search ml-2 mt-2"
          size="24px"
          type="button"
          onClick={() => setModalShow(true)}
        />
      </OverlayTrigger>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Advanced search</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group controlId="exampleForm.ControlSelect1">
            <Form.Label>Search Field</Form.Label>
            <Form.Control
              as="select"
              onChange={(e) => {
                setField(e.target.value);
              }}
            >
              <option value={'documentNo'}>PO #</option>
              <option value={'itemNo'}>Sku Code</option>
              <option value={'feedbackUser'}>Feedback User</option>
            </Form.Control>
          </Form.Group>
          <p>
            Please enter &nbsp;
            {field === 'itemNo' ? 'Sku Code' : field === 'documentNo' ? 'PO #' : 'Feedback User'} to
            search
          </p>
          <Form.Control
            size="sm"
            type="text"
            className="mr-2"
            placeholder={`Enter Search #`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {lines.length > 0 ? (
            <div className="mt-4">
              <p>Following PO lines found matching your search</p>
              <ListGroup>{ordersList}</ListGroup>
            </div>
          ) : (
            <></>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => searchOrder()}>Search</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AdvanceLinesSearch;
